<div class="table-filters">
    <div class="filter-button" (click)="openFilterMenu()">
        <app-custom-icon
            [iconPath]="'assets/icons/general-icons.svg'"
            [imageName]="'filter'"
            [imageSize]="'18'">
        </app-custom-icon>
        <span>Filter</span>
    </div>
    @for (filter of currentFilters | keyvalue; track filter.key) {
        @if (isDisplayable(filter)) {
            @switch (filter.key) {
                @case ("createdAt") {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [closeActive]="false"
                        [dataToDisplay]="filter.value | dateIntervalToString"
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
                @case ("individual") {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="
                            'Individual: ' +
                            (filter.value | findInList: userList)?.label
                        "
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
                @case ("groups") {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="
                            filter.value
                                | filterChipLabel: groupFilterOptions?.all : 'Group'
                        "
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
            }
        }
    }
</div>
